import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const ConfirmModalHeader = styled.div`
  @media only screen and (max-width: 480px) {
    padding: 0 15px 0 0;
  }
`;

export const ConfirmModalBody = styled.div`
  display: flex;
`;

export const ConfirmIconWrapper = styled.div`
  padding: 0 15px 0 5px;
  @media only screen and (max-width: 480px) {
    padding: 0 15px 0 0;
  }
`;

export const ConfirmModalContent = styled.div`
  flex-grow: 1;
  p {
    margin-bottom: 20px;
  }
`;

export const ConfirmDialogFooter = styled.div`
  @media only screen and (max-width: 480px) {
    display: flex;
    justify-content: space-between;
  }
  button {
    height: 38px;
    font-size: 13px;
    font-weight: 700;
    padding-left: 20px;
    padding-right: 20px;
    &.confirm_cancel_button {
      border: 0;
      background-color: transparent;
      box-shadow: none;
      color: ${themeGet('primary.0', '#194AB9')};
      margin-right: 10px;
    }
  }
`;
